<template>
  <ContextColorProvider context="brand">
    <div class="wallet-balance">
      <Row
        class="wallet-balance__row wallet-balance__row--mobile"
        :has-line="false"
      >
        <template #top-left>
          <BaseText size="sm" :color="NebraskaColors.textSecondary">
            {{ rowDescription }}
          </BaseText>
        </template>
        <template #bottom-left>
          <SkeletonLoader
            v-if="isLoading"
            data-testid="refresh-wallet-balance-loader"
            class="wallet-balance__refresh-loader"
          >
            <div />
          </SkeletonLoader>
          <BaseText v-else>{{ totalBalance }}</BaseText>
        </template>
      </Row>

      <Row class="wallet-balance__row wallet-balance__row--desktop">
        <template #top-left>
          <BaseText>{{ rowDescription }}</BaseText>
        </template>

        <template #top-right>
          <div class="wallet-balance__container">
            <SkeletonLoader
              v-if="isLoading"
              data-testid="refresh-wallet-balance-loader"
              class="wallet-balance__refresh-loader"
            >
              <div />
            </SkeletonLoader>
            <BaseText v-else>{{ totalBalance }}</BaseText>
          </div>
        </template>
      </Row>
      <div v-if="showTotalBtn" class="wallet-balance__btn-select-all">
        <ButtonSecondary label="Selecionar total" @click="selectTotal" />
      </div>
    </div>
  </ContextColorProvider>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  BaseIcon,
  BaseText,
  Row,
  SkeletonLoader,
  ButtonSecondary,
  ContextColorProvider
} from '@warrenbrasil/nebraska-web';

@Component({
  name: 'WalletBalance',
  components: {
    BaseText,
    Row,
    SkeletonLoader,
    BaseIcon,
    ButtonSecondary,
    ContextColorProvider
  }
})
export default class WalletBalance extends Vue {
  @Prop({ type: Boolean, default: true })
  public readonly isLoading!: boolean;

  @Prop({ type: Boolean, default: true })
  public readonly showTotalBtn!: boolean;

  @Prop({ type: String, required: false })
  public readonly totalBalance?: string;

  public get rowDescription() {
    return 'Total bruto disponível';
  }

  @Emit()
  public selectTotal() {}

  public get NebraskaColors() {
    return NebraskaColors;
  }
}
</script>

<style lang="less" scoped>
.wallet-balance {
  display: flex;
  flex-direction: column;
  gap: @size-spacing-x150;
  align-items: flex-start;
  .to-md({ flex-direction: row; align-items: center; justify-content: space-between; });
  &__row {
    margin-top: @spacing-xxs;
  }

  &__row--desktop {
    display: none;
  }

  &__row--mobile {
    width: 100%;
    margin-top: @size-spacing-x500;
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__refresh-loader {
    width: 100px;
    > div {
      background: @background-tertiary;
      height: 28px;
      border-radius: 10px;
    }
  }
  &__btn-select-all {
    .to-md({ display: flex; flex-shrink: 0; });
  }

  &__refresh-container {
    display: flex;
    align-items: center;
    padding-left: 4px;
    button {
      outline: none;
    }
    /deep/ span {
      display: flex;
    }
    &--mobile {
      button {
        outline: none;
      }
      /deep/ span {
        display: flex;
      }
    }
  }

  @media (min-width: 480px) {
    display: grid;
    grid-template-columns: 12fr 2fr;
    gap: @size-spacing-x500;
    margin-top: @spacing-m;
    align-items: flex-end;
    &__row--mobile {
      display: none;
    }

    &__row--desktop {
      display: block;
    }
  }
}
</style>
